import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import gfm from "@bytemd/plugin-gfm";
import highlight from "@bytemd/plugin-highlight";
import { Editor, Viewer } from "@bytemd/vue-next";
import { ref } from "vue";
import "highlight.js/styles/github.css"; // 引入代码高亮
/**
 *  定义组件属性类型
 */
interface Props {
  value: string;
}

// 给组件指定初始值

export default /*#__PURE__*/_defineComponent({
  __name: 'MdViewer',
  props: {
    value: { default: () => "" }
  },
  setup(__props: any) {

const props = __props;

const plugins = [
  gfm(),
  highlight(),
  // Add more plugins here
];

return (_ctx: any,_cache: any) => {
  const _component_markdown_body = _resolveComponent("markdown-body")!

  return (_openBlock(), _createBlock(_component_markdown_body, { id: "markdown-body" }, {
    default: _withCtx(() => [
      _createVNode(_unref(Viewer), {
        value: _ctx.value,
        plugins: plugins
      }, null, 8, ["value"])
    ]),
    _: 1
  }))
}
}

})